import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Modal from '../../../../common/modal/Modal';
import AddItineraryFoodForm from './AddItineraryFoodForm';
import { postItineraryAdditionalFood } from '../../../../../actions/itinerary/ItineraryAdditionalFood';
import { PUT } from '../../../../../config/permissions';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { ITINERARY_ADDITIONAL_FOOD_ENDPOINT } from '../../../../../config/endpoints';

export const AddItineraryFoodButton = ({
  itineraryId,
  dispatchPostItineraryAdditionalFood,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const closeModal = () => setShowModal(false);

  const onModalSubmit = async (formValues) => {
    const {
      supplierId,
      observation,
      itineraryAdditionalFoodTypeList = [],
    } = formValues;

    const foodTypeList = itineraryAdditionalFoodTypeList.map((item) => ({
      ...item,
      foodId: item.foodId ? item.foodId.value || item.foodId : null,
      quantity: item.quantity ? Number(item.quantity) : null,
      price: item.price ? Number(item.price) : null,
      publicType: item.publicType.value,
    }));

    const payload = {
      supplierId: supplierId ? supplierId.value || supplierId : null,
      comment: observation,
      itineraryAdditionalFoodTypeList: foodTypeList,
    };

    const response = await dispatchPostItineraryAdditionalFood(
      itineraryId,
      payload,
    );

    if (response) {
      closeModal();
    }
  };

  const openModal = () => {
    setShowModal(true);
  };

  const buildModalBody = () => {
    const newModalBody = (
      <AddItineraryFoodForm
        onCancel={closeModal}
        handleProcess={onModalSubmit}
      />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Alimentación Adicional"
        body={modalBody}
        size="lg"
      />
      <Button color="warning" className="border" onClick={openModal}>
        <i className="fa fa-plus" /> Alimentación Adicional
      </Button>
    </>
  );
};

AddItineraryFoodButton.propTypes = {
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  dispatchPostItineraryAdditionalFood: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostItineraryAdditionalFood: postItineraryAdditionalFood,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(AddItineraryFoodButton);

export default withEndpointAuthorization({
  url: ITINERARY_ADDITIONAL_FOOD_ENDPOINT,
  permissionType: PUT,
})(connectedComponent);
